
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

// NEW: global loader provider
import { GlobalLoaderProvider } from "./context/GlobalLoaderContext";

// Ensure dark mode class is set on body before React renders (for perfect sync on refresh)
if (localStorage.getItem('darkMode') === 'true') {
  document.body.classList.add('dark-mode');
} else {
  document.body.classList.remove('dark-mode');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GlobalLoaderProvider>
      <Router>
        <App />
      </Router>
    </GlobalLoaderProvider>
  </React.StrictMode>
);


reportWebVitals();
